import { HTMLAttributes } from 'react';

import { FontBoldIcon } from '@radix-ui/react-icons';
import { useEditorState, type Editor } from '@tiptap/react';

import { Toggle } from '../../../primitives/toggle';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

interface ToggleBoldProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
}

export function ToggleBold({ className, editor }: ToggleBoldProps) {
  const { isBold } = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isBold: editor.isActive('bold'),
    }),
  });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Toggle
            aria-label="Negrita"
            className={className}
            disabled={!editor.isEditable}
            pressed={isBold}
            size="icon"
            variant="ghost"
            onPressedChange={() => editor.chain().focus().toggleBold().run()}
          >
            <FontBoldIcon className="size-4" />
          </Toggle>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="flex flex-col">
          Negrita <span className="text-accent">⌘B</span>
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
